module.exports = __webpack_public_path__ + "img/9.af904ce0.jpg";